import { Tooltip } from "@blueprintjs/core";
import autobind from 'autobind-decorator';
import React from "react";

import { BlockView } from 'common/views/block/BlockView.view';
import { BoxView } from "common/views/box/Box.view";
import { CardView } from 'common/views/card/Card.view';
import { ImageView } from "common/views/image/Image.view";
import { RowsView } from "common/views/rows/Rows.view";
import { IQueryOne, QueryOne } from "core/api/query";
import { IPanelProps, Panel } from "core/decorators/Panel";
import Config from "./Config";
import { IconNames } from "@blueprintjs/icons/lib/esm";
import OrganizationMessages from "panels/organizations/admin/announcements/entities/OrganizationMessages";
import { FlexJustify } from "common/fragments/Flex";

@Panel({id: "organizations-admin-announcements", configClass: Config, pageParams: true})
@QueryOne(OrganizationMessages, {})
export default class OrganizationsAnnouncemets extends React.PureComponent<IPanelProps<Config> & IQueryOne<OrganizationMessages>> {

	@autobind
	public getQueryParams(): object {
			return {id: this.props.pageParams.id};
	}

	// This better be a number between 1 and 100. I aint got time to error check.
	// https://media0.giphy.com/media/bWM2eWYfN3r20/giphy.gif
	private getRandomCompletion(min, max) {
	    return (Math.random() * (max-min) + min)/100;
	}

	public render() {
		const { config, entity } = this.props;

		const messageCards = (entity && entity.messageList) && this.props.entity.messageList.map((message, index) => {

		    const { owner } = message;
				const src: string = (owner.avatar && owner.avatar.file && owner.avatar.file.url) || "https://placehold.it/80x80";

				return(
							<CardView viewKey="list-body" key={index}>
									<FlexJustify>
    				                    <div>
    				                    <ImageView
    											src={src}
    											viewKey="avatar-thumbnail"
    									/>
    				                    <span>{message.startDate} {config.dateResource} {message.endDate}</span>
    				                    </div>
    				                    <div>
    				                        <h2>{message.name}</h2>
						                    </div>
				                    </FlexJustify>
						                <FlexJustify>
						                    <div>
						                        <span>{message.summary}</span>
						                    </div>
				                    </FlexJustify>
				                    <div>

				                    </div>
						</CardView>
				);
			});

		return (

			<BoxView title={config.title} viewKey="organization-messagelist-box">
				<RowsView viewKey="organization-messagelist-rows">
					{messageCards}
				</RowsView>
			</BoxView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/announcements/OrganizationAnouncements.panel.tsx